import { render, staticRenderFns } from "./BirthValidationModal.vue?vue&type=template&id=660f9f60&scoped=true"
import script from "./BirthValidationModal.vue?vue&type=script&lang=js"
export * from "./BirthValidationModal.vue?vue&type=script&lang=js"
import style0 from "./BirthValidationModal.vue?vue&type=style&index=0&id=660f9f60&prod&scoped=true&lang=css"
import style1 from "./BirthValidationModal.vue?vue&type=style&index=1&id=660f9f60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660f9f60",
  null
  
)

export default component.exports